import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { format } from 'date-fns';
import PageBanner from './PageBanner';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const BASE_URL = process.env.REACT_APP_BASE_URL;


const getYouTubeId = (url) => {
  if (!url) return null;
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
};


const ViewPost = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const viewerRef = useRef(null);
  const quillViewer = useRef(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/posts/${id}`);
        const data = await response.json();
        setPost(data);
      } catch (error) {
        console.error('Error fetching post:', error);
      }
    };
    fetchPost();
  }, [id]);

  useEffect(() => {
    if (post && viewerRef.current && !quillViewer.current) {
      quillViewer.current = new Quill(viewerRef.current, {
        readOnly: true,
        theme: 'snow',
        modules: { toolbar: false }
      });
      quillViewer.current.root.innerHTML = post.content;
    }
  }, [post]);

  if (!post) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;

  return (
    <div className="min-h-screen pb-18">
      <PageBanner title={post.title} backgroundImage={post.titleImage} />
      <div className="max-w-7xl mx-auto px-4 py-8">
        <article className="ql-editor overflow-hidden">
          <div className="p-6">
            {post.type === 'video' && post.youtubeUrl && (
              <div className="aspect-w-16 aspect-h-9 mb-8">
                <iframe
                  
                  src={`https://www.youtube.com/embed/${getYouTubeId(post.youtubeUrl)}`}
                  title={post.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-[500px] rounded-xl"
                ></iframe>
              </div>
            )}
            {/* Render post content using Quill in read-only mode */}
            <div ref={viewerRef} className='text-xl'></div>
            {/* Footer with writer details */}
            <div className="mt-8 border-t border-gray-200 pt-4 text-gray-600">
              <p className="text-lg">Written by: <span className="font-semibold">{post.writtenBy}</span></p>
              <p className="text-lg">
                Written on: <span className="font-semibold">
                  {format(new Date(post.createdAt), 'MMMM d, yyyy')}
                </span>
              </p>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default ViewPost;
